module.exports = __webpack_public_path__ + "img/diners.ccae9f4.png";